import React from 'react';

export default function IconTradingProfile() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_674_33397)">
        <path
          d="M12.875 19.5645C17.0171 19.5645 20.375 16.2066 20.375 12.0645C20.375 7.92232 17.0171 4.56445 12.875 4.56445C8.73286 4.56445 5.375 7.92232 5.375 12.0645C5.375 16.2066 8.73286 19.5645 12.875 19.5645Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.875 12.3711C14.1157 12.3711 15.125 11.3618 15.125 10.1211C15.125 8.88038 14.1157 7.87109 12.875 7.87109C11.6343 7.87109 10.625 8.88038 10.625 10.1211C10.625 11.3618 11.6343 12.3711 12.875 12.3711Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.66992 17.463C8.74992 15.723 10.6849 14.5605 12.8749 14.5605C15.0649 14.5605 16.9999 15.7155 18.0799 17.463"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_674_33397">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3.875 3.06445)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
